import './playPage.css';
import Sketchbook from './Sketchbook/sketchbook';
import Button from '../components/Button/Button';
import bscCrawlMap from '../images/bsc/BSC_Crawl_Map.png';
import bscPicnic from '../images/bsc/picnic.png';

function PlayPage() {
  return (
    <div className="PlayPage">
      <div className="hobby-list">

        {/* STATIONERY CLUB ITEM */}
        <div className="hobby-item">
          <h2>Boston Stationery Club</h2>
          <div className="tags-list stats-pills">
            <span className="tag">1,400+ TikTok followers</span>
            <span className="tag">100+ Members</span>
          </div>
          <p>I founded Boston Stationery Club to bring together those that share a passion for pen and paper, and want to connect and meet others. We host monthly meetups, store crawls, picnics, and swap events all centered around a love of stationery.</p>
          <Button onClick={() => window.open('https://bostonstationeryclub.carrd.co/', '_blank')}>Visit Club Website</Button>
          <div className="bsc-fliers">
            {[
              { src: bscCrawlMap, alt: 'Stationery Store Crawl flier' },
              { src: bscPicnic, alt: 'Stationery Picnic flier' },
            ].map(({ src, alt }) => (
              <img key={alt} src={src} alt={alt} className="bsc-flier" />
            ))}
          </div>
        </div>

        {/* FAVORITES ITEM */}
        {/* <div className="hobby-item">
          <h2>Current Favorites</h2>
          <p>A few things I'm into right now.</p>
          <div className="favorites-grid">
            {[
              { emoji: '🖊️', label: 'My Pen' },
              { emoji: '🛹', label: 'Skateboard' },
              { emoji: '📓', label: 'Journal' },
            ].map(({ emoji, label }) => (
              <div className="favorite-item" key={label}>
                <span className="favorite-emoji">{emoji}</span>
                <span className="favorite-label">{label}</span>
              </div>
            ))}
          </div>
        </div> */}

        {/* SKETCHBOOK ITEM */}
        <div className="hobby-item sketchbook-item">
          <h2>Sketchbook</h2>
          <div className="sketchbook-container">
            <Sketchbook />
          </div>
        </div>

        {/* CREATIVE CODING ITEM */}
        <div className="hobby-item">
          <h2>Creative Coding</h2>
          <div className="creative-coding-content">
            <div className="creative-coding-title">
              <strong>The Anti-Cube Rule</strong>
            </div>
            <p>A satirical takedown of food taxonomy. Paradoxes, quantum food states, and the Choco Taco Dilemma.</p>
            <Button onClick={() => window.open('https://theanticuberule.netlify.app', '_blank')}>Visit Website</Button>
            <iframe
              src="https://theanticuberule.netlify.app"
              title="The Anti-Cube Rule"
              className="hobby-iframe"
            />
          </div>
        </div>

        {/* DIGITAL ART ITEM */}
        {/* <div className="hobby-item">
          <h2>Digital Art</h2>
          <p>Illustrations and digital paintings.</p>
        </div> */}

        {/* PHOTOGRAPHY ITEM */}
        {/* <div className="hobby-item">
          <h2>Photography</h2>
          <p>Capturing life's quiet moments.</p>
        </div> */}

      </div>

    </div>
  );
}

export default PlayPage;
